import { render } from "./bindOrderNOModel.vue?vue&type=template&id=72898d4b"
import script from "./bindOrderNOModel.vue?vue&type=script&lang=js"
export * from "./bindOrderNOModel.vue?vue&type=script&lang=js"

import "./bindOrderNOModel.vue?vue&type=style&index=0&id=72898d4b&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__